import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import BackgroundWeather from '../../../domain/entities/BackgroundWeather';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexBackgroundWeathersSuccess: {
      const result = action.payload as PaginatedResult<BackgroundWeather>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
